import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import RevealOnScroll from "@/components/site/RevealOnScroll";
import ScrollToTop from "@/components/site/ScrollToTop";
import SmoothScroll from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Properties from "@/pages/Properties";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

export default function App() {
    return (
        <div className="App font-sans bg-night text-cream min-h-screen">
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <RevealOnScroll />
                <div className="page-grain" aria-hidden="true" />
                <Navbar />
                <main className="relative z-[2]">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/properties" element={<Properties />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingActions />
                <Toaster position="top-center" theme="dark" />
            </BrowserRouter>
        </div>
    );
}
